<h5 class="workshop-service-spot__heading">
    <span>{{ workshopService?.title }}</span>
    <span *ngIf="workshopService?.price !== 0; else gratis"> {{ workshopService?.price | defaultcurrency }}</span>
    <ng-template #gratis>{{ 'generic.for_free' | translate }}</ng-template>
</h5>
<p class="workshop-service-spot__description">
    {{ workshopService?.description }}
</p>
<div class="workshop-service-spot__bottom-text">{{ workshopService?.bottomText }}</div>
<div class="workshop-service-spot__buttons">
     <app-link *ngIf="workshopService?.bookWorkshopButton as bookWorkshopButton" [link]="bookWorkshopButton" [classString]="'button--primary'">
    </app-link>
    <app-link *ngIf="workshopService?.contactButton as contactButton" [link]="contactButton" [classString]="'button--tertiary'"> </app-link>
</div>
<span class="workshop-service-spot__tag" *ngIf="workshopService?.tag" [ngClass]="tagClasses">{{ workshopService?.tag }}</span>
